import { InjectionToken } from '@angular/core';
import { AppProvidersConfig } from '../interfaces';

export const AppProvidersConfigToken = new InjectionToken<AppProvidersConfig>(
  'App Providers Config'
);
